// The school grades by term (1-3), matching the `term` check on assessments.
export const TERMS = [1, 2, 3];
